import Button from '@/components/Button'
import useModal from '@/hooks/use-modal/index'
import { useLocation, useNavigate } from '@/lib/router-dom'
import CreatePackageFolderModal from './components/create-package-folder-modal.jsx'
import Packages from './components/packages.jsx'
import Templates from './components/templates.jsx'
import Breadcrumbs from '@/componentsDS/Breadcrumbs/index.jsx'

const Page = () => {
	/*=================================================
			General
	================================================*/

	const { goTo } = useNavigate();
	const { currentPath } = useLocation();

	const breadcrumbItem = [
		{
			label: '',
			link: `/`,
		},
		{
			label: 'Package Sharing',
			link: `/package`
		}
	]

	const {
		visible: isShowCreateFolderModal,
		show: showCreateFolderModal,
		hide: hideCreateFolderModel
	} = useModal()

	const tabsItems = [
		{ label: ('My Packages'), active: true, path: '/package' },
		{ label: ('Templates'), active: false, path: '/package/templates' },
	]?.map((item) => ({
		...item,
		active:
			item.path === currentPath
	}))

	const handleCreatePackage = () => {
		goTo('/package/create')
	}

	return (
		<>
		<Breadcrumbs breadcrumbItems={breadcrumbItem} />
			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">Package Sharing</div>
				</div>

				<div className="title-header__right">
					<div className="overview__filter overview__button_wrap">
						{tabsItems[0].active && (
							<>
								<Button
									round
									ghost
									full
									text={'+ Create New Folder'}
									submit={showCreateFolderModal}
									disabled
								/>
								{/* <Button
									submit={handleCreatePackage}
									round
									full
									text={'+ Create New Package'}
								/> */}
							</>
						)}

					</div>
				</div>
			</div>

			{/* <div>
				<Tabs>
					{tabsItems.map((item, index) => (
						<Tab
							key={index}
							label={item.label}
							active={item.active}
							onClick={() => goTo(item.path)}
						/>
					))}
				</Tabs>
			</div> */}
			<div className="eclip-hr">
				<hr />
			</div>
			{/* <Switch>
				<Route path="/package" exact component={Packages} />
				<Route path="/package/templates" component={Templates} />
			</Switch> */}

			{currentPath === '/package' && <Packages />}
			{currentPath === '/package/templates' && <Templates />}

			<CreatePackageFolderModal
				visible={isShowCreateFolderModal}
				close={hideCreateFolderModel}
			/>
		</>
	)
}

export default Page
